import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';

import startOfMonth from 'date-fns/startOfMonth';
import endOfMonth from 'date-fns/endOfMonth';

import useCurrentLanguage from 'utils/hooks/useCurrentLanguage';
import { setSubmissionsCalendarDate } from 'store/entities/submissions';
import { getSubmissionsCalendar } from 'store/entities/submissions/thunks';
import { formatDateGlobal } from 'utils/dateUtils';

import SmallCalendar from 'components/SmallCalendar';
import { Column } from 'components/UIComponents/Layout';

const SubmissionsCalendar = () => {
  const { institutionId } = useParams();
  const dispatch = useDispatch();
  const language = useCurrentLanguage();

  const {
    submissionsCalendarDate,
    submissionsCalendar,
    reporter,
    institution,
  } = useSelector(state => state.submissions);

  const { userDetails } = useSelector(state => state.auth);

  useEffect(() => {
    getCalendarDates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submissionsCalendarDate, institutionId, reporter, institution]);

  const getCalendarDates = () => {
    const calendarQuery = {
      startDate: formatDateGlobal(startOfMonth(submissionsCalendarDate)),
      endDate: formatDateGlobal(endOfMonth(submissionsCalendarDate)),
      ...(institutionId || institution
        ? { institutionId: parseInt(institutionId) || institution?.value?.id }
        : {}),
      ...(reporter
        ? { reporterKeycloakId: reporter?.value?.keycloakId }
        : !institutionId
        ? { reporterKeycloakId: userDetails?.userId }
        : {}),
    };
    dispatch(getSubmissionsCalendar(calendarQuery));
  };

  return (
    <Column className="filters__calendar">
      <SmallCalendar
        month={submissionsCalendarDate}
        onMonthChange={date => dispatch(setSubmissionsCalendarDate(date))}
        showOutsideDays
        selectedDays={submissionsCalendar.map(({ date }) => new Date(date))}
        locale={language}
      />
    </Column>
  );
};

export default SubmissionsCalendar;
